<template>
  <footer class="footer">
    <div class="footer__block-top">
      <span class="footer__text">
        {{ 'footer.copyright' | globalize({ year: currentYear }) }}
      </span>
      <span class="footer__links">
        <language-picker class="footer__language-picker" />
      </span>
    </div>
    <div class="footer__block-bottom">
      <span class="footer__version">
        {{ packageVersion }}
      </span>
    </div>
  </footer>
</template>

<script>
import { vueRoutes } from '@/vue-router/routes'
import LanguagePicker from './footer/LanguagePicker'
import { PACKAGE_VERSION } from '@/js/const/package-json'

export default {
  name: 'app-footer',

  components: {
    LanguagePicker,
  },

  data: () => ({
    vueRoutes,
  }),

  computed: {
    currentYear () {
      return new Date().getFullYear()
    },

    packageVersion () {
      return 'v' + PACKAGE_VERSION
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~@scss/variables';

  .footer {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;
    padding: 1.5rem;

    &__block-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &__block-bottom {
      display: flex;
      margin-bottom: 0.5rem;
    }
  }

  .footer__text,
  .footer__link {
    line-height: 2.5rem;
  }

  .footer__language-picker {
    display: inline-block;
  }

  .footer__link {
    color: $col-footer-text;
  }

  .footer__text {
    color: $col-footer-text;
  }

  .footer__language-picker,
  .footer__link {
    margin: 0 1rem;

    &:not(:first-child) {
      margin-left: 0;
    }
  }
</style>
